import { useCallback, useState } from "react";
import { ReactFlow, applyNodeChanges, applyEdgeChanges, addEdge, Controls } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { CustomNode } from "./CustomNode";
import { TreeViewProps } from "./types";

const nodeTypes = {
  custom: CustomNode
}

const TreeView = ({
  initialNodes,
  initialEdges,
  enableNodeChange = false,
  enableEdgesChange = false,
  enableConnect = false,
  isPredecessors
}: TreeViewProps) => {
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);
 
  const onNodesChange = useCallback(
    (changes: any) => enableNodeChange && setNodes((nodesSnapshot: any) => applyNodeChanges(changes, nodesSnapshot)),
    [],
  );
  const onEdgesChange = useCallback(
    (changes: any) => enableEdgesChange && setEdges((edgesSnapshot: any) => applyEdgeChanges(changes, edgesSnapshot)),
    [],
  );
  const onConnect = useCallback(
    (params: any) => enableConnect && setEdges((edgesSnapshot: any) => addEdge(params, edgesSnapshot)),
    [],
  );

  const onNodeClick = useCallback((_: any, clickedNode: any) => {
    // 2. Identify the target IDs connected to this node
    const connectedEdgeIds = edges
      .filter((edge: any) => edge.source === clickedNode.id)
      .map((edge: any) => edge.id);
      
    const connectedNodeIds = edges
      .filter((edge: any) => edge.source === clickedNode.id)
      .map((edge: any) => edge.target);

    // 3. Update visibility
    setNodes((nds: any) =>
      nds.map((node: any) => {
        if (connectedNodeIds.includes(node.id)) {
          return { ...node, hidden: false };
        }
        return node;
      })
    );

    setEdges((eds: any) =>
      eds.map((edge: any) => {
        if (connectedEdgeIds.includes(edge.id)) {
          return { ...edge, hidden: false };
        }
        return edge;
      })
    );
  }, [edges, setNodes, setEdges]);
 
  return (
    <div style={{ width: '100vw', height: '50vh' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onNodeClick={onNodeClick}
        fitView
        fitViewOptions={{
          maxZoom: 1,
        }}
        key={isPredecessors ? 'pre' : 'suc'}
      >
        <Controls />
      </ReactFlow>
    </div>
  );
}

export default TreeView;